__turbopack_context__.v({
  "layer": "takeover-layer-link-component-module-scss-module__62pbcW__layer",
  "layer-link": "takeover-layer-link-component-module-scss-module__62pbcW__layer-link",
});
